import React from 'react';
import { motion } from 'framer-motion';
import Reveal from './Reveal';
import { MAX_SUPPLY_FULL, MAX_SUPPLY_LABEL } from '../data';
import '../styles/tokenomics.css';

const R = 80;
const C = 2 * Math.PI * R;
const BURN = 0.6 * C;   /* 3% of the 5% fee */
const STAKE = 0.4 * C;  /* 2% of the 5% fee */

const FACTS = [
  { k: 'launch', v: 'stealth launch — fair from block one' },
  { k: 'mechanics', v: 'descriptive of current token flows, not a promise' },
  { k: 'liquidity', v: '60% of WAX to Alcor, rest seeded across WAX LPs' },
  { k: 'community', v: 'provided for entertainment only' },
  { k: 'risk', v: 'no intrinsic value or expectation of financial return' },
  { k: 'compliance', v: 'users must ensure compliance with local laws' },
];

const stageVar = {
  hidden: {},
  show: { transition: { staggerChildren: 0.25, delayChildren: 0.1 } },
};
const arcVar = (len) => ({
  hidden: { strokeDashoffset: len },
  show: { strokeDashoffset: 0, transition: { duration: 1.1, ease: [0.22, 1, 0.36, 1] } },
});

const Tokenomics = () => (
  <section className="section tokenomics" id="tokenomics">
    <Reveal className="tok-head">
      <span className="eyebrow">tokenomics</span>
      <h2 className="section-title">transparent mechanics, <span className="accent">no promises</span></h2>
      <p className="section-lead">
        $KEK is an entertainment-only meme token. Any fee behavior is descriptive of current
        on-chain mechanics, not a guarantee of future value or return.
      </p>
    </Reveal>

    <div className="tok-grid">
      <Reveal className="tok-donut-wrap glass">
        <motion.div
          className="tok-donut-stage"
          variants={stageVar}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.4 }}
        >
          <svg className="tok-donut" viewBox="0 0 200 200" role="img" aria-label="Descriptive fee split illustration: majority removed from circulation, remainder to liquidity">
            <circle cx="100" cy="100" r={R} className="tok-track" />
            <motion.circle
              cx="100" cy="100" r={R} className="tok-arc tok-arc--burn"
              style={{ strokeDasharray: `${BURN} ${C}` }} transform="rotate(-90 100 100)"
              variants={arcVar(BURN)}
            />
            <motion.circle
              cx="100" cy="100" r={R} className="tok-arc tok-arc--stake"
              style={{ strokeDasharray: `${STAKE} ${C}` }} transform="rotate(126 100 100)"
              variants={arcVar(STAKE)}
            />
          </svg>
          <div className="tok-donut-center">
            <span className="tok-fee">5%</span>
            <span className="tok-fee-label">descriptive fee</span>
          </div>
        </motion.div>
        <div className="tok-legend">
          <span className="leg leg--burn"><i /> removed from circulation</span>
          <span className="leg leg--stake"><i /> liquidity/direction</span>
        </div>
      </Reveal>

      <div className="tok-side">
        <Reveal className="tok-supply glass">
          <span className="tok-supply-label">max supply</span>
          <span className="tok-supply-value">{MAX_SUPPLY_LABEL}</span>
          <span className="tok-supply-full">{MAX_SUPPLY_FULL} $KEK</span>
        </Reveal>
        <div className="tok-facts">
          {FACTS.map((f, i) => (
            <Reveal className="tok-fact glass" key={f.k} delay={i * 0.05}>
              <span className="tok-fact-key">{f.k}</span>
              <span className="tok-fact-val">{f.v}</span>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Tokenomics;
